var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile is-6 is-vertical"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }